import React from "react";
import { Box, Container, useTheme, useMediaQuery, Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import UserScoreHeader from "../Components/User/UserScores.component";
import UserTabs from "../Components/User/UserTabs.component";
const UserPage = () => {
  const { user } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container
      maxWidth="xl"
      sx={{
        py: { xs: 2, sm: 3, md: 4 },
        px: { xs: 1, sm: 2, md: 3 }
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        sx={{
          minHeight: '100vh'
        }}
      >
        {/* User Score Header - Full width on mobile, side panel on desktop */}
        <Grid
          item
          xs={12}
          lg={3}
          sx={{
            order: { xs: 1, lg: 1 }
          }}
        >
          <Box
            sx={{
              position: { lg: 'sticky' },
              top: { lg: theme.spacing(2) },
              height: { lg: 'fit-content' }
            }}
          >
            <UserScoreHeader userId={user} />
          </Box>
        </Grid>

        {/* User Tabs - Main content area */}
        <Grid
          item
          xs={12}
          lg={9}
          sx={{
            order: { xs: 2, lg: 2 }
          }}
        >
          <Box
            sx={{
              width: '100%',
              overflow: 'hidden' // Prevent horizontal scroll on mobile
            }}
          >
            <UserTabs userId={user} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );

};

export default UserPage;
